import { useEffect, useState, useRef } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { API_URL } from "../../shared/constant";
import { toast } from "react-toastify";
import axios from "axios";
import Select from "react-select";
import DatePicker from "react-date-picker";
import moment from 'moment';

const AddPurchaseReturn = () => {

    const navigate = useNavigate();
    const { id } = useParams();
    const selectInputRef = useRef();
    const [invoiceDate, setInvoiceDate] = useState(new Date());
    const [isLoading, setIsLoading] = useState(false);
    const [loading, setLoading] = useState(true);
    const [companyData, setCompanyData] = useState([]);
    const [products, setProducts] = useState([]);
    const [items, setItems] = useState([]);
    const [productData, setProductData] = useState({
        name: "",
        product_id: "",
        gst: "",
        qty: "",
        price: "",
        amount: "",
    });
    const [formData, setFormData] = useState({
        "supplier_id": "",
        "purchase_return_number":"",
        "invoice_no": "",
        "prefix": "",
        "round_off": "0",
        "sub_total": "0",
        "total_tax": "0",
        "total_amount": "0",
        "date": "",
        "items": []
    });
    const styles = {
        menu: (baseStyles, state) => ({
            ...baseStyles,
            marginTop: 2,
            zIndex: 999,
        }),
    };
        const getPurchasereturn = () => {
        axios.post(API_URL.PURCHASE_RETURN_LATEST, {}).then((res) => {
            if (res.data.status === 1) {
                setFormData({ ...formData, prefix: res.data.prefix, purchase_return_number: res.data.data });
            }
        });
    };


    const getCompany = () => {
        axios.post(API_URL.PARTY_LIST, { is_seller: [1] }).then((res) => {
            if (res.data && res.data.data && res.data.data.length > 0) {
                let pt = res.data.data.map((raw) => {
                    return {
                        address_one: raw.address_one,
                        address_two: raw.address_two,
                        city: raw.city,
                        gst_no: raw.gst_no,
                        state_name: raw.state_name,
                        name: raw.name,
                        label: raw.name + " - " + raw.contact_no,
                        value: raw.id,
                    };
                });
                setCompanyData(pt);
            }
        });
    }

    const getEdit = () => {
        axios.post(API_URL.PURCHASE_RETURN_GET, { id: id }).then((res) => {
            if (res.data.status == 1) {
                setFormData({
                    "supplier_id": (res.data.data.supplier_id) ? res.data.data.supplier_id : "",
                    "purchase_return_number": (res.data.data.purchase_return_number) ? res.data.data.purchase_return_number : "",
                    "invoice_no": (res.data.data.invoice_no) ? res.data.data.invoice_no : "",
                    "round_off": (res.data.data.round_off) ? res.data.data.round_off : "0",
                    "sub_total": res.data.data.sub_total,
                    "total_tax": res.data.data.total_tax,
                    "total_amount": res.data.data.total_amount,
                    "date": (res.data.data.date) ? res.data.data.date : "",
                    "remarks": (res.data.data.remarks) ? res.data.data.remarks : "",
                    "prefix": (res.data.data.prefix) ? res.data.data.prefix : "",
                    "items": [],
                });
                if (res.data.data.date) {
                    setInvoiceDate(new Date(res.data.data.date));
                }
                let rows = res.data.data.items.map((row) => {
                    return {
                        name: row.product.name + (row.subproduct ? " - " + row.subproduct.name : ""),
                        gst: row.product.gst,
                        qty: row.qty,
                        rate: row.rate,
                        amount: row.amount,
                        product_id: row.product_id,
                        grade_id: row.grade_id,
                        grade_name: row.grade?.name,
                        sub_product_id: row.sub_product_id
                    }
                });
                setItems(rows);
            } else {
                toast.error(res.data.data, { autoClose: 3000 });
            }
        });
    }

    const getProducts = () => {
        axios.post(API_URL.PRODUCT_WITH_SUB_LIST, {}).then((res) => {
            if (res.data && res.data.data && res.data.data.length > 0) {
                res.data.data.map((raw) => {
                    raw.label = raw.name;
                    raw.value = raw.id;
                });
                setProducts(res.data.data);
            }
            if (!id) {
                setLoading(false);
            }
        });
    };
    const setProductValue = (e) => {
        if (e) {
            setProductData({
                ...productData,
                name: e ? e.label : "",
                product_id: e ? e.product_id : null,
                sub_product_id: e ? e.sub_product_id : null,
                gst: e ? e.gst : "",
                rate: e.price ? e.price : 0,
                amount: (productData.qty) ? (productData.qty * e.price) : 0,
            });
        }
    };
    const addRow = () => {
        if (
            productData.product_id &&
            productData.qty &&
            productData.rate &&
            productData.amount
        ) {
            let cloneItems = [...items];
            cloneItems.push(productData);
            setItems(cloneItems);
            setProductData({
                name: "",
                product_id: "",
                sub_product_id: "",
                gst: "",
                qty: "",
                rate: "",
                amount: "",
            });
            selectInputRef.current.clearValue();
        }
    };
    const updateValue = (name, amt, value, k) => {
        const copyData = [...items]
        if (copyData[k]) {
            copyData[k][name] = value;
            if (name === 'qty')
                copyData[k][amt] = value * copyData[k]['rate']
            if (name === 'rate')
                copyData[k][amt] = value * copyData[k]['qty']

        }
        setItems(copyData);
    }

    const deleteRow = (index) => {
        const copyData = [...items]
        let newData = copyData.filter((e, key) => {
            return key != index;
        });
        setItems(newData)
    }

    const calculations = () => {
        let sub_total = 0;
        let total_qty = 0;
        let total_tax = 0;
        items.forEach((row) => {
            sub_total += parseFloat(row.amount);
            total_qty += parseFloat(row.qty);
            total_tax += (parseFloat(row.amount) * parseFloat(row.gst)) / 100;
        });
        let insurance_amount = 0;
        if (formData.insurance) {
            insurance_amount = (sub_total * formData.insurance) / 100;
            insurance_amount = insurance_amount.toFixed(2);
        }
        sub_total = sub_total.toFixed(2);
        let total_amount = parseFloat(sub_total) + parseFloat(insurance_amount);
        if (formData.round_off) {
            total_amount = parseFloat(total_amount) + parseFloat(formData.round_off);
        }
        if (total_tax) {
            total_tax = total_tax.toFixed(2);
            total_amount = parseFloat(total_amount) + parseFloat(total_tax);
        }
        total_amount = total_amount.toFixed(2);
        setFormData({
            ...formData,
            sub_total: sub_total,
            insurance_amount: insurance_amount,
            total_qty: total_qty,
            total_tax: total_tax,
            total_amount: total_amount,
        });
    }

    const saveCredit = () => {
        let payload = { ...formData };
        payload.items = [...items];
        payload.date = moment(invoiceDate).format('YYYY-MM-DD');
        const pUrl = API_URL.PURCHASE_RETURN_SAVE;
        if (id) {
            payload.id = id;
        }
        setIsLoading(true);
        axios.post(pUrl, payload).then((res) => {
            if (res.data.status === 1) {
                if (id) {
                    toast.success("Updated", {
                        autoClose: 3000,

                    });
                } else {
                    toast.success("Saved", { autoClose: 3000 });
                }
                setTimeout(() => {
                    navigate("/purchase-return", { replace: true });
                }, 100);
            } else {
                toast.error(res.data.data, { autoClose: 3000 });
            }
            setIsLoading(false);
        }, (error) => {
            setIsLoading(false);
        });
    }

    useEffect(() => {
        calculations();
    }, [items, formData.insurance, formData.round_off])

    useEffect(() => {
        getCompany();
        getProducts();
    }, [])

    useEffect(() => {
        if (id) {
            getEdit()
        }else{
            getPurchasereturn()
        }
    }, [id])
    return (
        <>
            <div className="row">
                <div className="col-6">
                    <h1>{id ? "Edit" : "Add"} Purchase Return</h1>
                </div>
                <div className="col-6">
                    <div className="d-flex align-items-center  justify-content-end">
                        <Link to={"/purchase-return"} className="btn btn-secondary">
                            <i className="fa fa-backward me-2" aria-hidden="true"></i>Back
                        </Link>
                    </div>
                </div>
                <div className="col-12">
                    <form onSubmit={(event) => event.preventDefault()}>
                        <div className="row mb-3">
                            <div className="col-md-6">
                                <div className="card">
                                    <h4 className="card-header">Company Details</h4>
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label htmlFor="name">Company</label>
                                                    <Select
                                                        options={companyData}
                                                        value={companyData.find((r) => r.value == formData.supplier_id)}
                                                        styles={styles}
                                                        onChange={(e) => {
                                                            setFormData({ ...formData, supplier_id: e.value });
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="card">
                                    <h4 className="card-header">Invoice Details</h4>
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label htmlFor="pan_no">Prefix</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        disabled
                                                        value={formData.prefix ? formData.prefix : ""}
                                                    />
                                                </div>
                                            </div>
                                             <div className="col-md-6">
                                                <div className="form-group">
                                                    <label htmlFor="invoiceno">Purchase Invoice No</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        value={formData.purchase_return_number}
                                                        onChange={(e) => setFormData({ ...formData, purchase_return_number: e.target.value })}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label htmlFor="invoiceno">Invoice No</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        value={formData.invoice_no}
                                                        onChange={(e) => setFormData({ ...formData, invoice_no: e.target.value })}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label htmlFor="">Date</label>
                                                    <DatePicker
                                                        format={'dd/MM/y'}
                                                        className="form-control"
                                                        onChange={setInvoiceDate}
                                                        value={invoiceDate}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <div className="card">
                                    <h4 className="card-header">Product Details</h4>
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-md-5">
                                                <div className="form-group">
                                                    <label htmlFor="exampleInputEmail1">Product</label>
                                                    <Select
                                                        ref={selectInputRef}
                                                        options={products}
                                                        styles={styles}
                                                        onChange={(e) => {
                                                            setProductValue(e);
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-2">
                                                <div className="form-group">
                                                    <label htmlFor="exampleInputEmail1">Qty</label>
                                                    <input
                                                        type="number"
                                                        onChange={(e) => {
                                                            setProductData({
                                                                ...productData,
                                                                qty: e.target.value,
                                                                amount:
                                                                    e.target.value * productData.rate
                                                                        ? e.target.value * productData.rate
                                                                        : 0,
                                                            });
                                                        }}
                                                        value={productData.qty}
                                                        className="form-control"
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-2">
                                                <div className="form-group">
                                                    <label htmlFor="exampleInputEmail1">Price</label>
                                                    <input
                                                        type="number"
                                                        onChange={(e) => {
                                                            setProductData({
                                                                ...productData,
                                                                rate: e.target.value,
                                                                amount:
                                                                    e.target.value * productData.qty
                                                                        ? e.target.value * productData.qty
                                                                        : 0,
                                                            });
                                                        }}
                                                        value={productData.rate}
                                                        className="form-control"
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-2">
                                                <div className="form-group">
                                                    <label htmlFor="exampleInputEmail1">Amount</label>
                                                    <input
                                                        type="text"
                                                        value={productData.amount}
                                                        className="form-control"
                                                        disabled
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-1">
                                                <div className="form-group">
                                                    <label>&nbsp;</label>
                                                    <div>
                                                        <i style={{ fontSize: 34, cursor: 'pointer' }} onClick={() => addRow()} className="simple-icon-plus"></i>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="card">
                            {items.length > 0 &&
                                <table className='table table-hover'>
                                    <thead className='thead'>
                                        <tr>
                                            <th>#</th>
                                            <th style={{ width: '45%' }}>Product</th>
                                            <th>Qty</th>
                                            <th>Price</th>
                                            <th>GST</th>
                                            <th>Amount</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            items.map((e, k) => {
                                                return <tr key={k}>
                                                    <td>{k + 1}</td>
                                                    <td style={{ width: '45%' }}>{e.name}</td>
                                                    <td><input type="number" onChange={(event) => { updateValue('qty', 'amount', event.target.value, k) }} className="form-control form-control-sm" value={e.qty} /></td>
                                                    <td><input type="number" onChange={(event) => { updateValue('rate', 'amount', event.target.value, k) }} className="form-control form-control-sm" value={e.rate} /></td>
                                                    <td><input type="text" className="form-control form-control-sm" value={e.gst + '%'} disabled /></td>
                                                    <td><input type="text" className="form-control form-control-sm" value={e.amount} disabled /></td>
                                                    <td style={{ cursor: "pointer", textAlign: 'right' }}>
                                                        <i style={{ fontSize: 34, cursor: 'pointer' }} onClick={() => { deleteRow(k) }} className="simple-icon-close text-danger"></i>
                                                    </td>
                                                </tr>
                                            })
                                        }
                                        <tr className="border-top">
                                            <td className="border-end" colSpan={4} align={'right'}></td>
                                            <td className="border-end" align={'right'}><strong>Sub Total</strong></td>
                                            <td colSpan={1} align={'right'}><strong>{formData.sub_total}</strong></td>
                                            <td></td>
                                        </tr>
                                        {(formData.insurance) ? <tr className="border-top">
                                            <td className="border-end" colSpan={4} align={'right'}></td>
                                            <td className="border-end" align={'right'}><strong>Insurance ({formData.insurance}%)</strong></td>
                                            <td colSpan={1} align={'right'}><strong>{formData.insurance_amount}</strong></td>
                                            <td></td>
                                        </tr> : null}
                                        <tr className="border-top">
                                            <td className="border-end" colSpan={4} align={'right'}></td>
                                            <td className="border-end" align={'right'}><strong>GST</strong></td>
                                            <td colSpan={1} align={'right'}><strong>{formData.total_tax}</strong></td>
                                            <td></td>
                                        </tr>
                                        <tr className="border-top">
                                            <td className="border-end" rowSpan={2} colSpan={4}>
                                                <label>Remarks</label>
                                                <input type={'text'} maxLength={255} value={formData.remarks} placeholder="remarks" className='form-control' onChange={(e) => setFormData({ ...formData, remarks: e.target.value })} />
                                            </td>
                                            <td className="border-end" align={'right'}><strong>Round Off</strong></td>
                                            <td colSpan={1} align={'right'}> <input type={'number'} value={formData.round_off} className='form-control form-control-sm text-right' onChange={(e) => setFormData({ ...formData, round_off: e.target.value })} /> </td>
                                            <td></td>
                                        </tr>
                                        <tr className="border-top">
                                            <td className="border-end" align={'right'}><strong>Final Amount</strong></td>
                                            <td colSpan={1} align={'right'}><strong>{formData.total_amount}</strong></td>
                                            <td></td>
                                        </tr>
                                    </tbody>
                                </table>
                            }
                        </div>
                    </form>
                    <div className="col-lg-12 col-md-12 col-sm-12 mt-3">
                        <div className="form-group text-right">
                            <button
                                type="button"
                                onClick={saveCredit}
                                // disabled={!isValidForm() || isLoading}
                                className="btn btn-primary" >
                                {isLoading ? <span className="spinner-border spinner-border-sm me-2" role="status"></span> : null}
                                Save
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AddPurchaseReturn;